import './CustomMenu.css';

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Toolbar, Typography, Card } from '@mui/material';
import { generateClassName, shouldRenderComponent } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';

const CustomMenu = ({ title, rolesAllowed, b2bProducts, menuItems, className = null }) => {
    const { loginData } = useContext(LoginContext);

    const shouldRender = shouldRenderComponent(loginData, rolesAllowed, b2bProducts);

    if (!shouldRender) {
        return null;
    }

    return (
        <Card className={generateClassName("custom-menu", "-container", className)}>
            <Toolbar className={generateClassName("custom-menu", "-toolbar", className)}>
                <Typography variant="h3" noWrap className={generateClassName("custom-menu", "-title", className)}>
                    {title}
                </Typography>
            </Toolbar>
            <Divider />
            <List className={generateClassName("custom-menu", "-list", className)}>
                {menuItems.map((section, index) => {
                    const shouldRenderSection = shouldRenderComponent(loginData, section.rolesAllowed, section.b2bProducts);
                    // const shouldRenderSection =
                    //     (loginData?.roles?.includes('ROLE_SUPER_ADMIN')) ||
                    //     ((!section.rolesAllowed || !section.rolesAllowed.length || section.rolesAllowed.some(role => loginData?.roles?.includes(role))) &&
                    //         (!section.b2bProducts || !section.b2bProducts.length || section.b2bProducts.every(product => loginData?.productAcronyms?.includes(product))));
                    if (!shouldRenderSection) {
                        return null;
                    }
                    return (
                        <div key={index} className={generateClassName("custom-menu", "-list-section", className)}>
                            <ListItem className={generateClassName("custom-menu", "-list-head", className)}>
                                {section.icon && <ListItemIcon className={generateClassName("custom-menu", "-list-head-icon", className)}>{section.icon}</ListItemIcon>}
                                <ListItemText primary={section.label} className={generateClassName("custom-menu", "-list-head-text", className)} />
                            </ListItem>
                            {section.items.map((item, itemIndex) => {
                                const shouldRenderItem = shouldRenderComponent(loginData, item.rolesAllowed, item.b2bProducts);
                                // const shouldRenderItem =
                                //     (loginData?.roles?.includes('ROLE_SUPER_ADMIN')) ||
                                //     ((!item.rolesAllowed || !item.rolesAllowed.length || item.rolesAllowed.some(role => loginData?.roles?.includes(role))) &&
                                //         (!item.b2bProducts || !item.b2bProducts.length || item.b2bProducts.some(product => loginData?.productAcronyms?.includes(product))));
                                if (!shouldRenderItem) {
                                    return null;
                                }

                                return (
                                    <React.Fragment key={itemIndex}>
                                        <ListItem component="button" onClick={item.onClick} style={{ paddingLeft: '30px' }} className={generateClassName("custom-menu", "-list-item", className)}>
                                            <ListItemIcon className={generateClassName("custom-menu", "-list-item-icon", className)}>{item.icon}</ListItemIcon>
                                            <ListItemText primary={item.label} className={generateClassName("custom-menu", "-list-item-text", className)} />
                                        </ListItem>
                                        {item.divider && <Divider variant="middle" />}
                                    </React.Fragment>
                                );
                            })}
                            {index < menuItems.length - 1 && <Divider />}
                        </div>
                    );
                })}
            </List>
        </Card>
    );
};

CustomMenu.propTypes = {
    title: PropTypes.string.isRequired,
    rolesAllowed: PropTypes.arrayOf(PropTypes.string),
    b2bProducts: PropTypes.arrayOf(PropTypes.string),
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element.isRequired,
            rolesAllowed: PropTypes.arrayOf(PropTypes.string),
            b2bProducts: PropTypes.arrayOf(PropTypes.string),
            items: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    icon: PropTypes.element.isRequired,
                    rolesAllowed: PropTypes.arrayOf(PropTypes.string),
                    b2bProducts: PropTypes.arrayOf(PropTypes.string),
                    onClick: PropTypes.func,
                    divider: PropTypes.bool,
                })
            ).isRequired,
        })
    ).isRequired,
};

export default CustomMenu;